<script>
	//need DB or flat file access for different puzzles
	//then let user pick game (or progress levels)
	//game screen given a specific problem
	export let GameID = 0;
	//should be populated from db
	//gamesaves
	import {LevelsID, NumberOfLevels} from './Levels.svelte';
	//stores
	import { user_levels } from './stores.js';
	//import { onMount } from 'svelte';
	//audio files
	import { audioData } from './audioData.js';
	//stores
	import {play_sound} from './stores.js';
	
	
	//&#9734; white star
	//&#9733; black star
	let levelnumbers = [];
	var i = 1;
    for ( i = 1; i <= NumberOfLevels; i++) {
        //find the next order
        let nextid = 0;
        for(let n in LevelsID)
        {    
            if(LevelsID[n].Order == i)
                nextid = LevelsID[n].ID;
        }
        //add the ids as the next number
        if(LevelsID[String(nextid)] != undefined)
            levelnumbers.push(String(nextid));
        //create all empty entries
        if($user_levels[String(nextid)] == undefined)
	    {
	        $user_levels[String(nextid)] = {'id':nextid,
	            'available':false, 'solved':false,
	            'program':'',
	            'cycles':9999,'io':9999,'cmds':9999};
	    }
    }
    
    
    let audioButtonclick  = new Audio(audioData['buttonclick'].url);
	
	function PlayClick(){
	    if ($play_sound)
	        audioButtonclick.play();
	}

	//returns the CS class for the button type if object
	function GetAvailability2(value) {
	    let ret = 'unavail_button';
	    //let work = $user_levels[value];
	    //alert(JSON.stringify($user_levels[value]));
	    //if key doesn't eist
	    if($user_levels[value] == undefined)
	    {
	        //alert('udef:' + value);
	        $user_levels[value] = {'id':parseInt(value),
	            'available':false, 'solved':false,
	            'program':'',
	            'cycles':9999,'io':9999,'cmds':9999};
	    }
	    //the first one is always available
	    if(value == '1'){
	        $user_levels[value]['available'] = true;
	    }
        if($user_levels[value]['available'] == true)
            ret = ($user_levels[value]['solved'] == true) ? 'done_button': 'avail_button';
        return ret;
	}
	
	function GetStar(usernum, level)
	{
	    //alert(usernum + " " + level);
	    let ret = ' ';
	    //beat the level
	    if (usernum < level)
	        ret = '<span style="color:#FF00FF;">&#9733;</span>';
	    else if (usernum == level)
	        ret = '<span style="color:#FFFF00;">&#9733;</span>';
	    
	    return ret;
	}
	
	
	function GetStats(value) {
	    //alert(JSON.stringify($user_levels[value]));
	    if($user_levels[value]['solved'] == false || $user_levels[value]['solved'] == undefined)
	        {    return "I: -  P: -  C: -";}
	    else{
	        //instructions
	        let cmds = $user_levels[value]['cmds'];
	        var stats = "I: " + cmds + GetStar(cmds, LevelsID[value].StarInst);
	        //ports
	        let ports = $user_levels[value]['io'];
	        stats = stats + " P: " + ports + GetStar(ports,LevelsID[value].StarPorts);
	        //cycles
	        let cycs = $user_levels[value]['cycles'];
	        stats = stats + " C: " + cycs + GetStar(cycs,LevelsID[value].StarCycles);
	        return stats;
	    }
	}
</script>
<style>
	#picklevs{
		width:270px;
		margin:auto auto;
		text-align:center;
		font-size:16px;
		font-weight:normal;
		font-family:"VT323",monospace;
	}
	.butt{
		width:60px;
		/*text-align:center;*/
		padding-right:30px;
		background-color:#000000;
	}
	.name{
		width:190px;
		padding-left:20px;
	}
	.desc{
		width:230px;
	}
	button{
		height:60px;
		width:60px;
		color:#000000;
		background-color:#ffffff;
		font-weight:bold;
		margin-top:2px;
	}
	.unavail_button{
		color:#000000;
		background-color:#ffffff;
	}
	.done_button{
		color:#ffffff;
		background-color:#000000;
		cursor:pointer;
	}
	.avail_button{
		color:#ffffff;
		background-color:#000000;
		border: 5px solid #fff;
		cursor:pointer;
	}
	.yellow{color:#FFFF00;}
	.purple{color:#FF00FF;}
	.rowstyle{
	   /*border: 2px inset #FFFFFF;*/
	   height:65px;
	   width:300px;
	   margin:auto auto;
	   text-align:left;
	}
	.rowtab {
	    height:100%;
	    width:100%;
	    border-right: 1px solid #111111;
	    border-bottom: 1px solid #191919;
	}
</style>

<!--{GetAvailability2(id)}-->
<div id="picklevs">
<h3>- Pick a level -</h3>
<p/>

	{#each levelnumbers as id, i}
		<p/>
		<div class="rowstyle">
		 <table class="rowtab" width="100%" height="100%" align="center" cellspacing="0" cellpadding="0">
             <tr><td rowspan="2" valign="middle" class="butt">
                 {#if GetAvailability2(id)=='unavail_button'}
                     <button on:click={PlayClick} on:click="{() => GameID = parseInt(id)}" class="{GetAvailability2(id)}" disabled>{i+1}</button>
                 {:else}
                     <button on:click={PlayClick} on:click="{() => GameID = parseInt(id)}" class="{GetAvailability2(id)}">{i+1}</button>
                 {/if}
                 </td>
            <td valign="top">{LevelsID[String(id)].Name}</td>
            </tr>
            <tr><td valign="top">{@html GetStats(id)}</td></tr>
		</table>
		</div>
		<!--<td valign="top" class="desc">{@html LevelsID[String(id)].Description.replaceAll('&','')}</td>-->
	{/each}
</div>